/**
 * Front Page Hero - Expandable tile interactions
 * Based on sliding panel approach - no grid reflow!
 */

// Animation timing constants (matches SCSS variables)
const ANIMATION_TIMINGS = {
    move: 400,      // $moveAT
    expand: 400,    // $expandAT
    delay: 50,      // $expandDelay
};

const FULL_CLOSE_TIME = ANIMATION_TIMINGS.move + ANIMATION_TIMINGS.expand + ANIMATION_TIMINGS.delay;

document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('.hero-courses-grid');
    const tiles = document.querySelectorAll('.hero-tile');
    const courseTiles = document.querySelectorAll('.hero-tile--course');

    if (!grid || !courseTiles.length) return;

    // Create tooltip element for desktop
    const tooltip = document.createElement('div');
    tooltip.className = 'hero-tile__tooltip';
    document.body.appendChild(tooltip);

    // Track mouse position for tooltip (desktop only)
    let currentHoveredTile = null;

    // Eagerly load videos when tiles scroll into view (helps iOS Safari)
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const video = entry.target.querySelector('.hero-tile__video');
                if (video && video.readyState < 3) {
                    video.load();
                }
                observer.unobserve(entry.target);
            }
        });
    }, { rootMargin: '200px' });

    courseTiles.forEach(tile => {
        observer.observe(tile);

        const video = tile.querySelector('.hero-tile__video');
        const poster = tile.querySelector('.hero-tile__poster');

        if (!video) return;

        // Only hide poster once video actually has frames
        video.addEventListener('playing', () => {
            if (poster) poster.style.opacity = '0';
        });

        // Hover to play video + show tooltip (desktop only)
        tile.addEventListener('mouseenter', () => {
            if (!tile.classList.contains('s--active')) {
                video.play().catch(err => console.log('Video play failed:', err));

                // Show tooltip with course title (desktop only)
                if (window.innerWidth >= 768) {
                    currentHoveredTile = tile;
                    const titleEl = tile.querySelector('.hero-tile__title');
                    if (titleEl) {
                        tooltip.textContent = titleEl.textContent;
                        tooltip.classList.add('is-visible');
                    }
                }
            }
        });

        // Stop video when hover ends (unless active) + hide tooltip
        tile.addEventListener('mouseleave', () => {
            if (!tile.classList.contains('s--active')) {
                video.pause();
                video.currentTime = 0;
                if (poster) poster.style.opacity = '1';

                // Hide tooltip
                currentHoveredTile = null;
                tooltip.classList.remove('is-visible');
            }
        });

        // Track mouse movement for tooltip positioning
        tile.addEventListener('mousemove', (e) => {
            if (currentHoveredTile === tile && window.innerWidth >= 768) {
                // Position tooltip with -10px offset (10px to the left of cursor)
                tooltip.style.left = (e.clientX + 15) + 'px';
                tooltip.style.top = e.clientY - 10 +'px';
            }
        });

        // Click to expand
        tile.addEventListener('click', (e) => {
            // Don't toggle if clicking the CTA link
            if (e.target.closest('.hero-tile__cta')) {
                return;
            }

            // If already active, do nothing
            if (tile.classList.contains('s--active')) return;

            e.preventDefault();

            // Store the tile's current position and size before going absolute
            const rect = tile.getBoundingClientRect();
            const gridRect = grid.getBoundingClientRect();
            tile.dataset.originalLeft = rect.left - gridRect.left;
            tile.dataset.originalTop = rect.top - gridRect.top;
            tile.dataset.originalWidth = rect.width;
            tile.dataset.originalHeight = rect.height;

            // Mark grid as having active element
            grid.classList.add('s--el-active');

            // Remove active from all tiles and reset their videos
            tiles.forEach(t => {
                if (t.classList.contains('s--active')) {
                    const otherVideo = t.querySelector('.hero-tile__video');
                    const otherPoster = t.querySelector('.hero-tile__poster');
                    if (otherVideo) {
                        otherVideo.pause();
                        otherVideo.currentTime = 0;
                    }
                    if (otherPoster) otherPoster.style.opacity = '1';
                }
                t.classList.remove('s--active');
            });

            // Set initial position before animation
            tile.style.left = tile.dataset.originalLeft + 'px';
            tile.style.top = tile.dataset.originalTop + 'px';
            tile.style.width = tile.dataset.originalWidth + 'px';
            tile.style.height = tile.dataset.originalHeight + 'px';

            // Add active to clicked tile (triggers absolute positioning)
            tile.classList.add('s--active');

            // Force reflow then trigger expansion
            requestAnimationFrame(() => {
                tile.style.left = '0';
                tile.style.top = '0';
                tile.style.width = '100%';
                tile.style.height = '100%';
            });

            // Play video (poster hides via 'playing' event listener)
            video.play().catch(err => console.log('Video play failed:', err));

            // Hide tooltip when expanding
            tooltip.classList.remove('is-visible');
            currentHoveredTile = null;
        });
    });

    // Function to close active tile with proper animation timing
    const closeTile = () => {
        const activeTile = document.querySelector('.hero-tile.s--active');
        if (!activeTile) return;

        // Add closing class
        activeTile.classList.add('s--closing');

        // Animate back to original position
        activeTile.style.left = activeTile.dataset.originalLeft + 'px';
        activeTile.style.top = activeTile.dataset.originalTop + 'px';
        activeTile.style.width = activeTile.dataset.originalWidth + 'px';
        activeTile.style.height = activeTile.dataset.originalHeight + 'px';

        // Remove active class
        activeTile.classList.remove('s--active');

        // Reset video
        const video = activeTile.querySelector('.hero-tile__video');
        const poster = activeTile.querySelector('.hero-tile__poster');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
        if (poster) poster.style.opacity = '1';

        // After full close animation completes, fade in other tiles and clean up
        setTimeout(() => {
            grid.classList.remove('s--el-active');
            activeTile.classList.remove('s--closing');
            // Clear inline styles so it returns to grid flow
            activeTile.style.left = '';
            activeTile.style.top = '';
            activeTile.style.width = '';
            activeTile.style.height = '';
        }, FULL_CLOSE_TIME);
    };

    // Close button click handler
    courseTiles.forEach(tile => {
        const closeBtn = tile.querySelector('.hero-tile__close');
        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                closeTile();
            });
        }
    });

    // Click outside to collapse
    document.addEventListener('click', (e) => {
        // If clicking outside the grid
        if (!e.target.closest('.hero-courses-grid')) {
            closeTile();
        }
    });
});